(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaBuOwnerFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$modal', 'biaBuOwnerService'];

    function Controller($rootScope, $scope, $state, $modal, biaBuOwnerService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.ctrlCtxt.canEditBUOwner =
            !$scope.boxContext.BIAProfile.IsReadOnly
            && $scope.boxContext.BIAProfile.HasBIAProfile_Edit_Related;

        $scope.ctrlCtxt.priorityLevels = $scope.boxContext.BCMLookups.PriorityLevels;

        var nextBUOwnerTaskValue = _.get($scope, 'boxModel.NextItemTaskDefinition.Value');

        $scope.ctrlCtxt.isReadyForPrioritization =
            $scope.boxContext.BIAResponsibilities.length
            && nextBUOwnerTaskValue !== 'NeedAllBIARespRatedForBUOwner';

        // Go To BIA Responsibility
        $scope.goToBIAResponsibility = function (resp) {
            $state.go('biaProfile.edit.biaBuOwner.biaResponsibility', {
                BIAResponsibilityID: resp.BIAResponsibilityID
            });
        };

        // Go To Add BIA Responsibilities
        $scope.goToAddBIAResponsibilities = function () {
            $state.go('biaProfile.edit.biaBuOwner.addBIAResponsibilities');
        };

        // Prioritize BIA Resps
        $scope.prioritizeBIAResps = function () {

            // Modal to show
            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = {};
            modalScope.boxModel = _.cloneDeep($scope.boxContext.BIAResponsibilities);
            modalScope.priorityLevels = $scope.ctrlCtxt.priorityLevels;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.list.modal.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            $scope.$on('modal.hide', function () {
                $state.reload();
            });

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };

        // Delete BU Owner
        $scope.deleteBUOwner = function () {
            biaBuOwnerService
                .deleteBIABUOwner($scope.boxModel.BIAProfileID, $scope.boxModel.BIABUOwnerID)
                .then(function () {
                    $state.go('^',{},{reload:true});
                });
        };

        // Edit Model Part
        $scope.editModelPart = function (partName) {
            // Modal to show
            var modalScope = $scope.$new(true);
            modalScope.ctrlCtxt = { };
            modalScope.boxModel = _.cloneDeep($scope.boxModel);
            modalScope.boxContext = _.cloneDeep($scope.boxContext);
            modalScope.isSaveChangesDisabled = $scope.isSaveChangesDisabled;
            modalScope.maxNbBiaBuOwner = $scope.maxNbBiaBuOwner;
            modalScope.onSave = $scope.onSave;

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
            var showModal = $modal({
	            scope: modalScope,
	            template: '/app/shared/BCM/BIAProfile/bcmBiaProfile.full_' + partName + '.tpl.html',
	            placement: 'center',
	            backdrop: 'static'
            });
        };
    }
})();